import { GetStaticPaths, GetStaticProps } from 'next';
import React from 'react';

import GreenReturnsLayout from '@/components/GreenReturnsLayout';
import AboutPersonLayout from '@/containers/aboutPerson/AboutPersonLayout';
import { getSingleContent } from '@/lib/apiService';

const AboutPerson: React.FC = ({ data }: any) => (
  <GreenReturnsLayout>
    <AboutPersonLayout data={data} bgGradient="none" bgColor="#197542" />
  </GreenReturnsLayout>
);

export default AboutPerson;

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async (ctx) => {
  const slug = ctx.params?.slug;
  if (typeof slug !== 'string') {
    return {
      notFound: true,
    };
  }

  const response = await getSingleContent('greenreturns_speakers', slug)
    .then((data) => data.content.data)
    .catch((err) => {
      console.error(err);
    });

  if (!response) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }
  return {
    props: {
      data: response,
      slug,
    },
    revalidate: 60,
  };
};
